import React, { useState } from "react";
import Modal from "./Modal";
import "./Projects.css";

export default function Projects({ data }) {
  const [hovered, setHovered] = useState(null);
  const [tilt, setTilt] = useState({ x: 0, y: 0, index: null });
  const [selectedProject, setSelectedProject] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = (project) => {
    setSelectedProject(project);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedProject(null);
  };

  const handleCardMove = (event, index) => {
    const rect = event.currentTarget.getBoundingClientRect();
    const x = ((event.clientX - rect.left) / rect.width - 0.5) * 16;
    const y = -((event.clientY - rect.top) / rect.height - 0.5) * 10;
    setTilt({ x, y, index });
  };

  const handleCardLeave = () => {
    setTilt({ x: 0, y: 0, index: null });
  };

  return (
    <section id="projects" className="projects section">
      <div className="container">
        <span className="section-label">04 — Projects</span>
        <h2 className="section-title">Selected<br />Work</h2>

        <div className="projects__list">
          {data.map((project, i) => (
            <div
              key={project.id}
              className={`project-card ${hovered === i ? "project-card--hovered" : ""}`}
              onMouseEnter={() => setHovered(i)}
              onMouseMove={(e) => handleCardMove(e, i)}
              onMouseLeave={() => {
                setHovered(null);
                handleCardLeave();
              }}
              onClick={() => openModal(project)}
              style={{
                cursor: "pointer",
                transform:
                  hovered === i
                    ? `perspective(900px) rotateY(${tilt.index === i ? tilt.x : 0}deg) rotateX(${tilt.index === i ? tilt.y : 0}deg) scale(1.02)`
                    : "none"
              }}
            >
              <div className="project-card__visual" style={{ background: project.bg }}>
                <div
                  className="project-card__accent-bar"
                  style={{ background: project.accent }}
                />
                <span className="project-card__abbr">{project.abbr}</span>
                <span className="project-card__num">{project.id}</span>
                <div
                  className="project-card__glow"
                  style={{ background: project.accent }}
                />
              </div>

              <div className="project-card__body">
                <span className="project-card__type">{project.type}</span>
                <h3 className="project-card__title">{project.title}</h3>
                <p className="project-card__desc">{project.desc}</p>
                <div className="project-card__link" style={{ color: project.accent }}>
                  View Details <span className="arrow">→</span>
                </div>
              </div>
            </div>
          ))}
        </div>

        <Modal
          isOpen={isModalOpen}
          onClose={closeModal}
          project={selectedProject}
        />
      </div>
    </section>
  );
}
